import React from 'react';
import { Check } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

const Pricing = () => {
  const packages = [
    {
      name: '2 Hours',
      price: '$361',
      duration: '2 Hours',
      squareUrl: 'https://square.link/u/sPrsaCRH',
      features: [
        'Unlimited instant images',
        'Customized photo strips',
        'Fun array of props',
        'Online photo access',
        'Touchscreen technology',
        'Basic backdrop',
        'Professional attendant',
        'Delivery & setup (20 miles)'
      ],
      popular: false
    },
    {
      name: '3 Hours',
      price: '$491',
      duration: '3 Hours',
      squareUrl: 'https://square.link/u/lqzUbbMj',
      features: [
        'Everything in 2 Hours',
        'Extended event coverage',
        'More time for photos',
        'Social media sharing',
        'Custom branding options',
        'Premium prop selection',
        'Photo strips & postcards',
        'Digital gallery'
      ],
      popular: true
    },
    {
      name: '4 Hours',
      price: '$701',
      duration: '4 Hours',
      squareUrl: 'https://square.link/u/xccHRGxp',
      features: [
        'Everything in 3 Hours',
        'Full event coverage',
        'Maximum photo opportunities',
        'Custom backdrop upgrade',
        'Enhanced prop collection',
        'Priority support',
        'Extended digital access',
        'Premium customization'
      ],
      popular: false
    }
  ];

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="pricing" className="py-20 px-4 bg-cream-bg">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-logo-navy vintage-title mb-4">
            Digital Photo Booth Packages
          </h2>
          <p className="text-xl text-logo-navy-light max-w-2xl mx-auto">
            Choose the perfect package for your event - all include our full photo booth experience
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <Card 
              key={index}
              className={`relative p-8 bg-white border-2 transition-all hover:shadow-2xl ${
                pkg.popular 
                  ? 'border-accent-warm shadow-xl transform scale-105' 
                  : 'border-logo-teal/30 hover:border-logo-teal'
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-accent-warm text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                    MOST POPULAR
                  </span>
                </div>
              )}
              
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-logo-navy mb-2">
                  {pkg.name}
                </h3>
                <div className="mb-4">
                  <span className="text-5xl font-bold text-logo-teal">
                    {pkg.price}
                  </span>
                </div>
                <p className="text-logo-navy-light font-semibold">
                  {pkg.duration} of Fun
                </p>
              </div>
              
              <ul className="space-y-3 mb-8">
                {pkg.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start gap-3">
                    <Check className="w-5 h-5 text-logo-teal flex-shrink-0 mt-0.5" />
                    <span className="text-logo-navy-light text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <Button 
                asChild
                data-testid={`book-package-btn-${pkg.name.replace(/\s+/g, '-').toLowerCase()}`}
                className={`w-full py-6 text-lg font-bold rounded-lg transition-all ${
                  pkg.popular
                    ? 'bg-accent-warm hover:bg-accent-warm/90 text-white shadow-lg'
                    : 'bg-logo-teal hover:bg-logo-teal-dark text-white'
                }`}
              >
                <a href={pkg.squareUrl} target="_blank" rel="noopener noreferrer">
                  Book This Package
                </a>
              </Button>
            </Card>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-logo-navy-light">
            Need a custom package? <button onClick={scrollToContact} className="text-logo-teal font-bold hover:underline">Contact us</button> for tailored options!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;